import i18n from '@/i18n';
import Vue from 'vue';
import {EventBus} from '@/event-bus.js';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import moment from 'moment';
function initialState () {
  return {
    app: {
      layout: null,
      is_rtl: false,
      colors: null,
      isFullScreenMode: false
    },
    // in reference of multiple screening urls
    currentFilmIndex: 0,
    preRollEnded: false,
    i18n_locale: i18n.locale,
    // in reference to player time
    currentTime: null,
    currentScreenerId: null,
    isEmbedMode: false,
    darkMode : false,
    fontFamily: DEFINES.DEFAULT_FONTS,
    liveConsumers: 0
  };
}

const state = initialState ();

// actions

const actions = {
  showMessage: (context, payload) => {
    EventBus.$emit ('showMessage', payload);
  },

  showAlert: (context, payload) => {
    EventBus.$emit ('showAlert', payload);
  },

  hideAlert: context => {
    EventBus.$emit ('hideAlert');
  },

  hideMessage: context => {
    EventBus.$emit ('hideMessage');
  },

  setAppLayout (context, payload) {
    context.commit ('set_app_layout', payload);
  },

  showLoader (context) {
    EventBus.$emit ('showLoader');
  },

  hideLoader (context) {
    EventBus.$emit ('hideLoader');
  },

  updateLocale (context, payload) {
    context.commit ('set_locale', payload);
  },

  setTheme (context, payload) {
    context.commit ('set_locale', {
      locale: payload.company.custom_properties.language,
    });
    context.commit ('set_rtl', {
      rtl: payload.company.custom_properties.is_rtl,
    });
    context.commit ('set_colors', payload.company.custom_properties.theme);
    context.commit ('set_dark_mode', payload.company.custom_properties);
    context.commit ('set_font_family', payload.company.custom_properties);
  },

  showSupportNotification: (context, payload) => {
    EventBus.$emit ('showSupportNotification', payload);
  },
  enableEmbedMode: (context, payload) => {
    context.commit ('enable_embed', {
      isEmbed: payload.isEmbed
    });
  },

  resetTheme (context, payload) {
    context.commit ('set_locale', {
      locale: DEFINES.THEME.PLATFORM.LOCALE,
    });
    context.commit ('set_rtl', {
      rtl: DEFINES.THEME.PLATFORM.RTL,
    });
    context.commit ('set_colors', {});
  },
  async setFullScreenMode (context, payload) {
    await context.commit ('set_full_screen_mode', payload);
  },
  async setLiveConsumers (context, payload) {
    await context.commit ('set_live_consumers', payload);
  }
};

// getters
const getters = {
  getField,
  isLoggedIn: (state, getters, rootState) => {
    return (
      rootState.auth.session_mode == DEFINES.SESSION_MODE_CONSUMER &&
      rootState.auth.key &&
      rootState.auth.secret
    );
  },
  getAuthScreener: (state, getters, rootState) => {
    return rootState.auth.screener;
  },
  appLayout: state => state.app.layout,
  isEmbedMode: state => state.isEmbedMode,
  darkMode: state => state.darkMode,
  fontFamily: state => state.fontFamily,
  getCurrentLanguage: state => state.i18n_locale,
  getLiveConsumers: state => state.liveConsumers
};

// mutations
const mutations = {
  updateField,
  set_app_layout (state, payload) {
    // console.log ('old layout:', state.app.layout);
    state.app.layout = payload.layout;
    // console.log ('new layout:', state.app.layout);
  },

  set_locale (state, payload) {
    // Change global locale (app's locale)
    i18n.locale = payload.locale;
    // Change locale for the company
    state.i18n_locale = payload.locale;
    // Setting locale for date also.
    moment.locale (i18n.locale);
  },

  set_rtl (state, payload) {
    state.app.is_rtl = payload.rtl;
    Vue.prototype.$vuetify.rtl = payload.rtl;
  },

  set_dark_mode(state, payload){
    if (payload.hasOwnProperty("darkMode")) {
      state.darkMode = payload.darkMode;
    }
  },

  set_font_family(state, payload){
    if (payload.hasOwnProperty("fontFamily")) {
      state.fontFamily = payload.fontFamily;
    }
  },
  set_colors (state, payload) {
    // Default colors
    let DEFAULT = DEFINES.THEME.PLATFORM.COLORS;
    let colors = {
      primaryColor: payload.primaryColor || DEFAULT.PRIMARY,
      secondaryColor: payload.secondaryColor || DEFAULT.SECONDARY,
      backgroundColor: payload.backgroundColor || DEFAULT.BACKGROUND,
    };
    // setting colors in global state
    state.app.colors = colors;
    // Setting in vuetify
    Vue.prototype.$vuetify.theme.primary = colors.primaryColor;
    Vue.prototype.$vuetify.theme.secondary =colors.secondaryColor;
    Vue.prototype.$vuetify.theme.background = colors.backgroundColor;
  },
  enable_embed (state, payload) {
    state.isEmbedMode = payload.isEmbed
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
  resetPlayerConifg (state) {
    const s = initialState ();
    let resetVar = [ "currentFilmIndex","preRollEnded","currentTime","currentScreenerId"]
    Object.keys (s).forEach (key => {
      if(resetVar.includes(key)){
        state[key] = s[key];
      }
    });
  },
  set_full_screen_mode (state, payload) {
    state.app.isFullScreenMode = payload;
  },
  set_live_consumers (state,payload) {
    state.liveConsumers = payload
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
